import React from "react";
import dayjs from "dayjs";
import { SharedDateInput } from "src/components";
import type { ThemeMode } from "../types";

type CalendarDateInputProps = {
    value: string;
    onChange: (value: string) => void;
    themeMode?: ThemeMode;
    variant?: "field" | "task";
};

const toDate = (value: string): Date | null => {
    if (!value) return null;
    const date = dayjs(value);
    return date.isValid() ? date.toDate() : null;
};

export function CalendarDateInput({ value, onChange }: CalendarDateInputProps) {
    return (
        <SharedDateInput
            value={toDate(value)}
            onChange={(date: Date | null) => onChange(date ? dayjs(date).format("YYYY-MM-DD") : "")}
            placeholder="Select date"
            onCalendarOpen={() => undefined}
            onCalendarClose={() => undefined}
        />
    );
}
